import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { Accordion } from "react-bootstrap";
import { extractWarnCaseMessages, formatMessagesWithAnd } from "../utils/messageExtractor";
import "../App.css";

const RightSideBar = ({ isUploadRoute = false, diroStatusData = null }) => {
  const [activeKey, setActiveKey] = useState(null);

  // Extract message fields from diroStatusData.capture.warn_case
  const warnCaseMessages = diroStatusData ? extractWarnCaseMessages(diroStatusData) : [];

  return (
    <div className="d-flex justify-content-start align-self-start w-100 pt-4 pt-lg-0 pb-lg-0 pb-md-0 pb-5 mb-3 mb-lg-0 mb-md-0">
      <div
        className={`overflow-scroll align-items-start me-md-5 ms-md-5 scrollbar-area me-lg-0 pe-lg-5 pe-5 ipad-air-class w-100 pt-lg-0 pt-md-0 pt-lg-0 pr-0 `}
        // style={{ marginRight: '0px !important' }}
      >
        <div className="right-line">
          <div className="scrollbar-text ms-md-0">
            <p className="fs-5" style={{ fontWeight: "500", padding: "0", fontFamily: "bwekBoldFont", textAlign: "left" }}>
              <span className="fs-5 overflow" style={{ color: "black" }}>
                {" "}
                Frequently asked questions{" "}
              </span>
            </p>
            <Accordion
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
              className="accord custom-accordion"
              style={{ color: "#787878", fontFeatureSettings: "ss06" }}
            >
              {isUploadRoute ? (
                // Upload route FAQs
                <>
                  <Accordion.Item eventKey="0" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "0" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        {" "}
                        What information will be shared?
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          Your uploaded document will not be shared with BW Epic Kosan. Only the fields requested
                          {warnCaseMessages && warnCaseMessages.length > 0
                            ? `, such as ${formatMessagesWithAnd(warnCaseMessages)}`
                            : ", such as your name, address, account number, IBAN, or routing number,"}{" "}
                          will be shared. All other data will be purged.
                        </li>
                        {diroStatusData && diroStatusData.additional_info && (
                          <li style={{ color: "#787878" }}>{diroStatusData.additional_info}</li>
                        )}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "1" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        Can I upload a modified version of my document?{" "}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          Verification works best when you provide the original, unaltered document. Your privacy is protected—we
                          only share the requested fields. Any changes or tampering may affect the document’s authenticity. Once
                          submitted, verification starts immediately and is usually completed within 24 hours.
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "2" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        Why should I trust DIRO?{" "}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          DIRO is trusted by Fortune 500 and Tier 1 global banks in consumer and enterprise verifications across
                          195 countries. Its solution is used to verify bank account ownership, proof of address, and other
                          documents to eliminate fraud, email spoofing, and impersonation issues.
                        </li>
                        <li style={{ color: "#787878" }}>Visit DIRO to learn more about vendor onboarding.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "3" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        How DIRO creates a new global standard?
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          DIRO's solution eliminates the possibility of document fraud, email spoofing, and impersonation issues.
                        </li>
                        <li style={{ color: "#787878" }}>
                          DIRO's ephemeral architecture of each session does not permit, or make possible, any storage of
                          passwords or other login credentials. This makes the solution particularly applicable to bank account
                          verification and proof of address in consumer and enterprise onboarding to eliminate fraud. DIRO's
                          verification of bank statements and utility bills provides verification of selected source data directly
                          from the bank or utility company without the possibility of tampering.
                        </li>
                        <li style={{ color: "#787878" }}>
                          KYB (Know Your Business) is mostly a manual process with uploads of simple PDFs which is open to
                          tampering, fake, and stolen data. This can lead to fraud and money laundering. DIRO is solving this
                          problem by creating a new global standard for document verification in KYB and vendor onboarding.
                        </li>
                        <li style={{ color: "#787878" }}>
                          DIRO participated in the UK's{" "}
                          <a
                            href="https://www.fca.org.uk/firms/innovation/regulatory-sandbox/accepted-firms"
                            target="blank"
                            rel="noopener"
                            className="anchor"
                          >
                            FCA (Financial Conduct Authority) sandbox for KYC
                          </a>{" "}
                          in 2019 (cohort 5) with its bank account verification and proof of address solution.
                        </li>
                        <li style={{ color: "#787878" }}>
                          In addition to the UK's FCA, DIRO is in conversation with regulators including FATF, FinCEN, Malta
                          Gaming Authority, Central Bank of India, Central Bank of Bahrain, Central Bank of Malaysia, and others.
                          The purpose of these conversations is to help regulators strengthen KYC, KYB, and AML requirements with
                          advancing technology.
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </>
              ) : (
                // Default FAQs
                <>
                  <Accordion.Item eventKey="0" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "0" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        {" "}
                        What information will be shared?
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          Your bank statement will not be shared with BW Epic Kosan. Only selected fields as highlighted inside
                          each session will be shared. All other data will be purged.
                        </li>
                        <li style={{ color: "#787878" }}>
                          Your utility bill will not be shared with BW Epic Kosan. Only selected fields as highlighted inside each
                          session will be shared. All other data will be purged.
                        </li>
                        <li style={{ color: "#787878" }}>
                          Any sensitive information such as balance, transactional data, or usage, from your bank statement or
                          utility bill will never be shared with BW Epic Kosan.
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "1" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        How does my password remain private?{" "}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          The entire verification session provides end-to-end encryption and remains private. In other words, you
                          will not share your password or login credentials with DIRO or BW Epic Kosan.
                        </li>
                        <li style={{ color: "#787878" }}>Most banks use one-time passwords (OTP) with multi-layer security.</li>
                        <li style={{ color: "#787878" }}>
                          Most banks use two-factor authentication (2FA) or multi-factor authentication (MFA). The second factor
                          is sometimes offline or on a separate device, such as a smartphone for high security and to eliminate
                          fraud.
                        </li>
                        <li style={{ color: "#787878" }}>
                          Since you will not do a transaction, only verify bank account ownership and proof of address, your
                          transaction password will never be asked for in the verification session.
                        </li>
                        <li style={{ color: "#787878" }}>Visit DIRO to learn more about user privacy.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "2" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        Why should I trust DIRO?{" "}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0 ">
                      <p className="ps-4" style={{ color: "#787878" }}>
                        DIRO is trusted by F500 and Tier 1 global banks in consumer and enterprise verifications across 195
                        countries. Its solution is used to verify bank account ownership, proof of address, and other documents to
                        eliminate fraud, email spoofing, and impersonation issues.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3" className="border-0">
                    <Accordion.Header>
                      <FontAwesomeIcon icon={activeKey === "3" ? faMinus : faPlus} className="text-dark-yellow me-2" />
                      <span className="fs-6" style={{ color: "black" }}>
                        How DIRO creates a new global standard?
                      </span>
                    </Accordion.Header>
                    <Accordion.Body className="pe-0">
                      <ul>
                        <li style={{ color: "#787878" }}>
                          DIRO's solution eliminates the possibility of document fraud, email spoofing, and impersonation issues.
                        </li>
                        <li style={{ color: "#787878" }}>
                          DIRO's ephemeral architecture of each session does not permit or make possible any storage of passwords
                          or other login credentials. This makes the solution particularly applicable to bank account verification
                          and proof of address in consumer and enterprise onboarding to eliminate fraud.
                        </li>
                        <li style={{ color: "#787878" }}>
                          DIRO's verification of bank statements and utility bills provides verification of selected source data
                          directly from the bank or utility company without the possibility of tampering.
                        </li>
                        <li style={{ color: "#787878" }}>
                          KYB (Know Your Business) is mostly a manual process with uploads of simple PDFs which is open to
                          tampering, fake, and stolen data. This can lead to fraud and money laundering. DIRO is solving this
                          problem by creating a new global standard for document verification in KYB.
                        </li>
                        <li style={{ color: "#787878" }}>
                          DIRO participated in the UK's{" "}
                          <a
                            href="https://www.fca.org.uk/firms/innovation/regulatory-sandbox/accepted-firms"
                            target="blank"
                            rel="noopener"
                            className="anchor"
                          >
                            FCA (Financial Conduct Authority) sandbox for KYC
                          </a>{" "}
                          in 2019 (cohort 5) with its bank account verification and proof of address solution.
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </>
              )}
            </Accordion>

            <div className="fs-6 pt-3" style={{ textAlign: "start" }}>
              <span className="" style={{ color: "black" }}>
                Learn more about DIRO's{" "}
              </span>
              <a href="https://diro.io/products/bank-account-verification/" target="_blank" className="anchor">
                <span className="">bank </span>
              </a>{" "}
              <span className="" style={{ color: "black" }}>
                {" "}
                account{" "}
              </span>
              {!isUploadRoute && (
                <>
                  <span className="" style={{ color: "black" }}>
                    and{" "}
                  </span>
                  <a href="https://diro.io/products/utility-bill-verification/" target="_blank" className="anchor">
                    <span className="">address </span>
                  </a>{" "}
                </>
              )}
              <span style={{ color: "black" }}>verification solutions.</span>
            </div>
            <div className="py-2 pt-3 fs-6" style={{ marginBottom: "0rem", textAlign: "start" }}>
              <span className="pe-2 ">
                <a href="https://diro.io/term-condition/" className="anchor" target="_blank">
                  Terms of Use.
                </a>
              </span>
              {"  "}
              <span className="pe-2 ">
                <a href="https://diro.io/privacy-policy/" className="anchor" target="_blank">
                  Privacy Policy.
                </a>
                {"  "}
              </span>

              {/* <span>
              <a
                href="https://trust.diro.io/"
                className="anchor"
                target="_blank"
              >
                 Trust Center
              </a>
            </span> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
